var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.steps)?_c(_setup.TitledProgressStepper,_vm._g({attrs:{"steps":_vm.steps}},_vm.$listeners)):_vm._e(),(_vm.steps)?_c('KeepAlive',[_c('RouterView')],1):_c('RouterView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }